import { EntityState } from '@ngrx/entity';
import { Configuration } from './models/configuration.model';
import { configurationEntityAdapter } from './adapters/configuration.adapter';

export type ConfigurationsSubState = EntityState<Configuration>;

export interface GenesysCloudWebDeploymentsState {
  configurations: ConfigurationsSubState;
}

export const initialConfigurationsSubState = (): ConfigurationsSubState => configurationEntityAdapter.getInitialState();

export const initialState = (): GenesysCloudWebDeploymentsState => ({
  configurations: initialConfigurationsSubState()
});
